/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import cx from "classnames";
import { useRouter } from "next/router";
import dynamic from "next/dynamic";

import TrendingImg from "@assets/icons/trending.svg";
// import leftArrowWhiteImg from "@assets/icons/leftArrowWhite.svg";

import http from "@apiServices/http";
import urls from "@apiServices/apiUrls";
import Article from "@components/templates/Article";
import { useInView } from "react-cool-inview";
import DiscoverMoreWidget from "@components/templates/DiscoverMore";
import Head from "next/head";
import NavigationBar from "@components/pages/ssrPage/NavigationBar";
import { setCookie } from "@utils/util";
import { doc, getDoc, getFirestore, setDoc } from "firebase/firestore/lite";
import { nanoid } from "nanoid";
import ArticleTracking from "@utils/articleTracking";
import ImageLoadingObserver from "@utils/imageLoadingObserver";

import { trackPageLoad } from "@components/pages/newsPage/ch-events";
import { pageSize } from "@components/pages/feedPage/constants";
// import { scrollToTop } from "@utils/scrollToTop";
import { useTheme } from "next-themes";
import { getCookies } from "cookies-next";
import { serverErrorLogger } from "@analytics/ErrorLogger/server";
import Link from "next/link";
import VideoArticle from "@components/templates/VideoArticle";
import firestoreService from "@firestoreServices/firestoreServices";

const DownloadAppPopup = dynamic(() => import("@components/templates/DownloadAppPopup"));
const EmptyStateView = dynamic(() => import("@components/templates/emptyStates/pageView"));

const SignMeUpWidget = dynamic(() => import("@components/templates/SignMeUpWidget"));

const DownloadAppWidget = dynamic(() => import("@components/templates/DownloadAppWidget"));
const EndOfContent = dynamic(() => import("@components/templates/EndOfContent"));
const ErrorEndOfContent = dynamic(() => import("@components/templates/EndOfContent/error"));
const DownloadApp = dynamic(() => import("@components/templates/EndOfContent/downloadApp"));

const widgets = ["download", "subscribe", "discoverMore"];
let showArticleCard = false;

const getFeedDetails = (feedTemp) => {
  if (feedTemp.length) {
    feedTemp.map((el, index) => {
      if (feedTemp.length >= 5 && index === 4 && el !== "discoverMore") {
        feedTemp.splice(index, 0, "discoverMore");
      }
      // if (feedTemp.length >= 15 && index === 14 && el !== "download") {
      //   feedTemp.splice(index, 0, "download");
      // }
      // if (feedTemp.length >= 20 && index === 19 && el !== "subscribe") {
      //   feedTemp.splice(index, 0, "subscribe");
      // }
    });

    // If.lenth < 5 push discover more in the last
    if (feedTemp.length >= 5) {
      if (feedTemp[4] !== "discoverMore") {
        feedTemp.splice(4, 0, "discoverMore");
      }
    } else if (!feedTemp.includes("discoverMore")) {
      feedTemp.push("discoverMore");
    }
  }
  return feedTemp;
};

const SearchDetails = ({
  handleBackClick,
  closeDownloadAppDrawer,
  noContentRelatedFeed,
  pageError = false,
  metaData,
  pageValue,
  userLikeArticlesData,
  ...props
}: any) => {
  const router = useRouter();
  const { query } = router;
  const { news } = query;

  const [data, setData] = useState(props?.data || []);
  const [userLikeArticles, setUserLikeArticles] = useState([]);
  const [userBookmarkArticles, _setUserBookmarkArticles] = useState([]);
  const [currentPage, setCurrentPage] = useState(Number(pageValue + 1));
  const [removeCount, setRemoveCount] = useState(0);
  const [isSignUp, setIsSignUp] = useState(false);
  const [isFetchError, setFetchError] = useState(false);
  const [isMoreLoading, setIsMoreLoading] = useState(false);
  const [discoverMoreTags, _setDiscoverMoreTags] = useState(props.discoverMoreTags || []);
  const [endOfContent, setEndOfContent] = useState(false);
  // const [hideScrollToTop, setHideScrollToTop] = useState(true);
  const [observer, setObserver] = useState(null);
  const [imageObserver, setImageObserver] = useState(null);
  const [mounted, setMounted] = useState(false);
  const [ShowDownloadAppPopup, setShowDowloadAppPopup] = useState(false);
  const [seenArticleList, setSeenArticleList] = useState([]);
  const [seenArticle, setSeenArticle] = useState(null);
  const [readArticleList, setReadArticleList] = useState([]);
  const [readArticle, setReadArticle] = useState(null);
  const [showEndOfContentDownloadAppCard, setShowEndOfContentDownloadAppCard] = useState(false);
  const baseUrl = process.env.NEXT_PUBLIC_BASE_URL;

  const value: any = news;
  let articleCount = 0;
  let downloadAppBannerTimer = null;
  const { theme } = useTheme();
  const cookies = getCookies();

  const getUserFirestoreData = async () => {
    const firestore = new firestoreService();
    const userFirestoreData = await firestore.getUserData();
    setUserLikeArticles(userFirestoreData?.likes || []);

    return userFirestoreData;
  };

  // const { observe: endOfContentObserver } = useInView({
  //   onEnter: () => {
  //     // Triggered when the target enters the viewport
  //     const container =
  //       document.getElementById("unsupported-browser-container") ||
  //       document.getElementById("container");

  //     // DISABLE THE GLOBAL APP DOWNLOAD POPUP
  //     downloadAppBannerTimer = setTimeout(() => {
  //       //@ts-ignore
  //       if (window.globalAppPopupTimer) {
  //         //@ts-ignore
  //         clearTimeout(window.globalAppPopupTimer);
  //         //@ts-ignore
  //         window.globalAppPopupTimer = null;
  //       }
  //       setShowDowloadAppPopup(true);
  //       container.classList.add("disable-scroll");
  //     }, 2000);
  //   },
  //   onLeave: () => {
  //     setShowDowloadAppPopup(false);
  //   }
  // });

  useEffect(() => {
    const temp = [...seenArticleList];
    const readArticleListTemp = [...readArticleList];
    getUserFirestoreData();
    const articleTrackingObserver = new ArticleTracking(
      {},
      (id) => {
        temp.push(id);
        setSeenArticle(id);
        setSeenArticleList(temp);
      },
      (id) => {
        readArticleListTemp.push(id);
        setReadArticle(id);
        setReadArticleList(readArticleListTemp);
      }
    );
    setObserver(articleTrackingObserver);
    const imageLoadingObserver = new ImageLoadingObserver();
    setImageObserver(imageLoadingObserver);
    const container =
      document.getElementById("unsupported-browser-container") ||
      document.getElementById("container");
    container.classList.remove("disable-scroll");
    return () => {
      articleTrackingObserver.destroy();
      imageLoadingObserver.destroy();
      clearTimeout(downloadAppBannerTimer);
    };
  }, []);
  useEffect(() => {
    const imageLoadingObserver = new ImageLoadingObserver();
    setImageObserver(imageLoadingObserver);
    return () => {
      imageLoadingObserver.destroy();
    };
  }, [theme]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (window.__bgtracker) {
        trackPageLoad();
        clearInterval(intervalId);
      }
    }, 500);
  }, []);

  useEffect(() => {
    const container =
      document.getElementById("unsupported-browser-container") ||
      document.getElementById("container");

    container.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }, [router.query.news]);

  useEffect(() => {
    // const isSignUpValue = !!localStorage.getItem("isSignUp") || false;
    const isSignUpValue = !!cookies["isSignUp"] || false;
    setIsSignUp(isSignUpValue);
    setMounted(true);
  }, []);

  const { observe } = useInView({
    // For better UX, we can grow the root margin so the data will be loaded earlier
    rootMargin: "50px 0px",
    // When the last item comes to the viewport
    onEnter: ({ unobserve }) => {
      setIsMoreLoading(true);
      // Pause observe when loading data
      unobserve();
      // Load more data
      fetchMoreData();
    }
  });

  const fetchMoreData = () => {
    setFetchError(false);
    const url =
      props?.slugDetail.slugType === "tag"
        ? urls.searchSeoTag({
            page: currentPage,
            id: props?.slugDetail.slugRequestPayload,
            size: pageSize
          })
        : urls.searchSeoPagination({
            input: props.slugDetail.slugRequestPayload,
            page: currentPage,
            size: pageSize
          });

    http
      .get(url)
      .then((res: any) => {
        setFetchError(false);

        // if (currentPage !== 0) {
        const temp = [...data, ...res.items];
        let feedDatWithWidgets = getFeedDetails(temp);
        setCurrentPage(currentPage + 1);

        // SHOW READ MORE ON APP END OF CONTENT IF FEED LIMIT IS REACHED
        // if (feedDatWithWidgets.length > feedPageLimit) {
        //   feedDatWithWidgets = feedDatWithWidgets.slice(0, feedPageLimit);

        //   setCurrentPage(currentPage + 1);
        //   setShowEndOfContentDownloadAppCard(true);
        // } else {
        //   setShowEndOfContentDownloadAppCard(false);
        //   setEndOfContent(true);
        // }

        // SHOW END OF CONTENT IF RESPONSE LENGTH < PAGE SIZE
        if (res.items.length < pageSize) {
          setShowEndOfContentDownloadAppCard(false);
          setEndOfContent(true);
        }
        setData(feedDatWithWidgets || []);
        // } else {
        //   setData(res?.items || []);
        //   setShowEndOfContentDownloadAppCard(true);
        // }

        // if (res.length === 0 || res.length < pageSize) {
        //   setEndOfContent(true);
        // }
      })
      .catch(() => {
        setFetchError(true);
        setShowEndOfContentDownloadAppCard(false);
      })
      .finally(() => {
        setIsMoreLoading(false);
      });
  };

  const removeNotInterestedArticle = (articleId) => {
    setData(data.filter((searchData) => searchData?.id !== articleId));
  };

  // const { observe: firstElementObserve } = useInView({
  //   threshold: 0.25, // Default is 0
  //   onEnter: () => {
  //     // Triggered when the target enters the viewport
  //     setHideScrollToTop(true);
  //   },
  //   onLeave: () => {
  //     // Triggered when the target leaves the viewport
  //     setHideScrollToTop(false);
  //   }
  // });

  let imgToPreload = [];
  if (data.length) {
    let count = 0;
    for (let i = 0; i < data.length && count < 2; i++) {
      if (!(typeof data[i] === "string" && widgets.includes(data[i]))) {
        if (data[i]?.mediaURL) {
          imgToPreload.push(data[i].mediaURL);
          count++;
        }
      }
    }
  }

  if (data?.length === 0 && noContentRelatedFeed?.length) {
    let count = 0;
    for (let i = 0; i < noContentRelatedFeed.length && count < 2; i++) {
      if (
        !(typeof noContentRelatedFeed[i] === "string" && widgets.includes(noContentRelatedFeed[i]))
      ) {
        if (noContentRelatedFeed[i]?.mediaURL) {
          imgToPreload.push(noContentRelatedFeed[i].mediaURL);
          count++;
        }
      }
    }
  }

  const showEndOfContentCard =
    endOfContent && !isFetchError && !isMoreLoading && !showEndOfContentDownloadAppCard;

  let articleObj = {};
  if (data) {
    articleObj = {
      "@context": "http://schema.org/",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          item: { "@id": "/", name: "Home" }
        },
        {
          "@type": "ListItem",
          position: 2,
          item: {
            "@id": `/${props?.slugDetail?.slug}`,
            name: props?.slugDetail?.slugDisplayName
          }
        }
      ]
    };
  }
  return (
    <>
      <Head>
        {data.length && (
          <link
            rel="canonical"
            href={
              (Number(pageValue) === 0
                ? `${baseUrl}/${news}`
                : `${baseUrl}/${news}?page=${Number(pageValue + 1)}`) || "https://techminis.com"
            }
            key="canonical"
          />
        )}
        {Number(pageValue) > 0 && data.length && (
          <link
            rel="prev"
            href={
              Number(pageValue) === 1
                ? `${baseUrl}/${news}`
                : `${baseUrl}/${news}?page=${Number(pageValue)}`
            }
          />
        )}
        {Number(pageValue) < Number(metaData?.totalPages - 1) && data?.length && (
          <link rel="next" href={`${baseUrl}/${news}?page=${Number(pageValue) + 2}`} />
        )}
        <title>
          {props?.slugDetail?.pageTitle ||
            "Techminis | Providing short summaries for crisp and quick read"}
        </title>
        <meta
          name="description"
          content={
            props?.slugDetail?.metaDescription ||
            "Providing short summaries for crisp and quick read"
          }
        />
        {!!data && (
          <script
            type="application/ld+json"
            id="microdata-breadcrumbs"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(articleObj) }}
          />
        )}
        <meta
          property="og:title"
          content={
            props?.slugDetail?.pageTitle ||
            "Techminis | Providing short summaries for crisp and quick read"
          }
          key="og:title"
        />
        <meta
          property="og:description"
          content={
            props?.slugDetail?.metaDescription ||
            "Providing short summaries for crisp and quick read"
          }
          key="og:description"
        />
        {!!!data?.length && !!!noContentRelatedFeed?.length && (
          <meta name="robots" content="noindex" key="robots" />
        )}
        {imgToPreload.length
          ? imgToPreload.map((img, ind) => <link key={ind} rel="preload" as="image" href={img} />)
          : null}
      </Head>

      {pageError && (
        <EmptyStateView
          type="error500"
          className="h-full p-5"
          onClick={() => router.reload()}
          noNavigationBar={true}
        />
      )}
      {!pageError && (
        <>
          <NavigationBar
            onLogoClick={() => {
              if (
                window &&
                window.__bgHistory &&
                window.__bgHistory.lastLocation &&
                window.__bgHistory.lastLocation === "/naukri"
              ) {
                router.push(`/naukri?mode=naukri&showTrendingFeed=${true}`, "/naukri?mode=naukri");
              } else {
                router.push(`/?showTrendingFeed=${true}`, "/");
              }
            }}
            handleOnSignup={() => setIsSignUp(true)}
          />
          {data?.length ? (
            <div className=" mb-4 flex w-full items-center bg-N100 px-5 pt-1 dark:bg-DN050">
              <Link href={baseUrl} passHref prefetch={false}>
                <a
                  title="home"
                  className="text-readingTextSmall  font-bold leading-readingTextSmall text-N900 line-clamp-3 dark:text-DN900"
                >
                  <span className="mr-2">Home</span>
                </a>
              </Link>
              <p className="mr-1.5 text-readingTextSmall  font-bold leading-readingTextSmall text-N900 line-clamp-3 dark:text-DN900">
                &gt;
              </p>

              <span className="mr-2 text-readingTextSmall  font-medium leading-readingTextSmall text-N500 dark:text-N100">
                {props?.slugDetail?.slugDisplayName || "Trending News"}
              </span>
            </div>
          ) : null}
          {!!!data?.length && (
            <div
              className="flex flex-col items-center justify-center"
              // style={{
              //   height: "calc(100vh - 74px)"
              // }}
            >
              {noContentRelatedFeed?.length > 0 && (
                <>
                  <div
                    className={cx(
                      "z-10 flex w-full flex-col items-start bg-N100 px-5 pt-5 dark:bg-DN050"
                    )}
                  >
                    <div className="flex w-full flex-col justify-between bg-N100 transition-none dark:bg-DN050">
                      <div>
                        <h1
                          className={cx(
                            "z-0 overflow-hidden text-ellipsis pt-0 font-IBMPlexSans text-titleL font-bold leading-titleL text-N900 dark:text-DN900",
                            ""
                          )}
                        >
                          {props?.slugDetail?.slugDisplayName || "Trending News"}
                        </h1>
                      </div>
                      <p className="font-normal text-readingTextMedium leading-readingTextMedium text-N500 dark:text-DN500">
                        No articles available for {props?.slugDetail?.slugDisplayName}.
                      </p>
                    </div>
                  </div>
                  <h2
                    className={cx(
                      "z-0 mt-6 -mb-3 w-full overflow-hidden text-ellipsis px-5 text-left font-IBMPlexSans text-title font-bold leading-title text-N900 dark:text-DN900",
                      ""
                    )}
                  >
                    Related reads
                  </h2>
                  {noContentRelatedFeed?.map((articleData, index) => {
                    if (typeof articleData === "string" && widgets.includes(articleData)) {
                      showArticleCard = false;
                    } else {
                      articleCount++;
                      showArticleCard = true;
                    }
                    return (
                      <div
                        key={index}
                        ref={
                          // index === 0 ? firstElementObserve : null
                          index === data.length - 1 ? observe : null
                        }
                      >
                        {articleData.newsBiteType == "NEWS_WRAP" && (
                          <VideoArticle
                            key={index}
                            index={index}
                            articleData={articleData}
                            className="mb-1 mt-5"
                            userLikeArticles={userLikeArticles}
                          />
                        )}
                        {showArticleCard && articleData.newsBiteType == "SHORT_ARTICLE" && (
                          <Article
                            index={index}
                            className="flex h-full w-full cursor-pointer flex-col justify-between border-b-[3px] border-P100 bg-N100 duration-300 dark:border-DG700 dark:bg-DN050"
                            closeDownloadAppDrawer={closeDownloadAppDrawer}
                            key={articleData.id}
                            isTrending={false}
                            articleData={articleData}
                            removeNotInterestedArticle={removeNotInterestedArticle}
                            userLikeArticles={userLikeArticles}
                            hideFollowOptionFromThreeDotDrawer={true}
                            userBookmarkArticles={userBookmarkArticles}
                            isSourceHidden
                            savedKeyword={value}
                            toggleFollowBtn={() => {}}
                            isFollowing={false}
                            setRemoveCount={setRemoveCount}
                            removeCount={removeCount}
                            showFullDescription={true}
                            observer={observer}
                            lazyLoadImage={articleCount <= 2 ? false : true}
                            imageObserver={imageObserver}
                            page="news_details"
                            articleSeen={articleData.id === seenArticle}
                            seenArticleList={seenArticleList}
                            articleRead={articleData.id === readArticle}
                          />
                        )}
                        {articleData === "discoverMore" && discoverMoreTags.length && (
                          <div className="flex h-full w-full cursor-pointer flex-col justify-between overflow-hidden border-b border-P100 bg-N100 px-5 duration-300 dark:border-DG700 dark:bg-DN050">
                            <DiscoverMoreWidget
                              discoverMoreTags={discoverMoreTags || []}
                              observer={observer}
                            />
                          </div>
                        )}
                      </div>
                    );
                  })}
                  {showEndOfContentDownloadAppCard && !isMoreLoading && (
                    <div
                      className="flex h-full w-full flex-col items-center justify-center"
                      // ref={endOfContentObserver}
                    >
                      <DownloadApp />
                    </div>
                  )}
                  {/* DOWNLOAD APP POPUP */}
                  {/* {ShowDownloadAppPopup && (
                    <DownloadAppPopup
                      observer={observer}
                      handleOnDownload={() => {
                        setShowDowloadAppPopup(false);
                        const container =
                          document.getElementById("unsupported-browser-container") ||
                          document.getElementById("container");
                        container.classList.remove("disable-scroll");
                      }}
                      onClose={() => {
                        setShowDowloadAppPopup(false);
                        const container =
                          document.getElementById("unsupported-browser-container") ||
                          document.getElementById("container");
                        container.classList.remove("disable-scroll");
                      }}
                    />
                  )} */}
                </>
              )}

              {noContentRelatedFeed?.length === 0 && (
                <>
                  <EmptyStateView
                    type="noFeed"
                    onClick={() => {
                      if (window && window.__bgHistory && window.__bgHistory.lastLocation) {
                        router.back();
                      } else {
                        router.push(`/?showTrendingFeed=${true}`, "/");
                      }
                    }}
                    mounted={mounted}
                  />

                  {discoverMoreTags.length && (
                    <div className="flex h-full w-full cursor-pointer flex-col justify-between  bg-N100 px-5 duration-300  dark:bg-DN050">
                      <DiscoverMoreWidget
                        discoverMoreTags={discoverMoreTags || []}
                        observer={observer}
                      />
                    </div>
                  )}
                </>
              )}
            </div>
          )}
          {data?.length ? (
            <div>
              <div
                className={cx(
                  "z-10 flex w-full flex-col items-start bg-N100 px-5 pt-0 dark:bg-DN050"
                )}
              >
                <div className="flex w-full justify-between bg-N100 transition-none dark:bg-DN050">
                  <div>
                    <h1
                      className={cx(
                        "dark:text-DN900mb-5 z-0 overflow-hidden text-ellipsis pt-0 font-IBMPlexSans text-titleL font-bold capitalize leading-titleL text-N900",
                        ""
                      )}
                    >
                      {props?.slugDetail?.slugDisplayName || "Trending News"}
                    </h1>
                  </div>
                </div>
              </div>
              <div
                className="mx-auto my-0 bg-N100 dark:bg-DN050"
                // style={{
                //   height: "calc(100vh - 144px)",
                // }}
              >
                {data.map((articleData: any, index: number) => {
                  if (typeof articleData === "string" && widgets.includes(articleData)) {
                    showArticleCard = false;
                  } else {
                    articleCount++;
                    showArticleCard = true;
                  }
                  return (
                    <div
                      key={index}
                      ref={
                        // index === 0 ? firstElementObserve : null
                        // index === 0 ? firstElementObserve : index === data.length - 1 ? observe : null
                        index === data.length - 1 ? observe : null
                      }
                    >
                      {articleData === "download" && <DownloadAppWidget observer={observer} />}
                      {articleData === "subscribe" && !isSignUp && (
                        <SignMeUpWidget isSuccessMode={isSignUp} observer={observer} />
                      )}
                      {articleData === "discoverMore" && discoverMoreTags.length && (
                        <div className="flex h-full w-full cursor-pointer flex-col justify-between overflow-hidden border-b-[3px] border-P100 bg-N100 px-5 duration-300 dark:border-DG700 dark:bg-DN050">
                          <DiscoverMoreWidget
                            discoverMoreTags={discoverMoreTags || []}
                            observer={observer}
                          />
                        </div>
                      )}

                      {articleData.newsBiteType == "NEWS_WRAP" && (
                        <VideoArticle
                          key={index}
                          index={index}
                          articleData={articleData}
                          className={`mb-1 ${index === 0 ? "" : "mt-5"}`}
                          userLikeArticles={userLikeArticles}
                        />
                      )}
                      {showArticleCard && articleData.newsBiteType == "SHORT_ARTICLE" && (
                        <Article
                          index={index}
                          className="mt-5 flex h-full w-full cursor-pointer flex-col justify-between border-b-[3px] border-P100 bg-N100 duration-300 dark:border-DG700 dark:bg-DN050"
                          closeDownloadAppDrawer={closeDownloadAppDrawer}
                          key={articleData.id}
                          isTrending={false}
                          articleData={articleData}
                          removeNotInterestedArticle={removeNotInterestedArticle}
                          userLikeArticles={userLikeArticles}
                          hideFollowOptionFromThreeDotDrawer={true}
                          userBookmarkArticles={userBookmarkArticles}
                          isSourceHidden
                          savedKeyword={value}
                          toggleFollowBtn={() => {}}
                          isFollowing={false}
                          setRemoveCount={setRemoveCount}
                          removeCount={removeCount}
                          showFullDescription={true}
                          observer={observer}
                          lazyLoadImage={articleCount <= 2 ? false : true}
                          imageObserver={imageObserver}
                          articleSeen={articleData.id === seenArticle}
                          seenArticleList={seenArticleList}
                          articleRead={articleData.id === readArticle}
                        />
                      )}
                    </div>
                  );
                })}
                {showEndOfContentDownloadAppCard && !isMoreLoading && (
                  <div
                    className="flex h-full w-full flex-col items-center justify-center"
                    // ref={endOfContentObserver}
                  >
                    <DownloadApp />
                  </div>
                )}
                {/* DOWNLOAD APP POPUP */}
                {/* {ShowDownloadAppPopup && (
                  <DownloadAppPopup
                    observer={observer}
                    handleOnDownload={() => {
                      setShowDowloadAppPopup(false);
                      const container =
                        document.getElementById("unsupported-browser-container") ||
                        document.getElementById("container");
                      container.classList.remove("disable-scroll");
                    }}
                    onClose={() => {
                      setShowDowloadAppPopup(false);
                      const container =
                        document.getElementById("unsupported-browser-container") ||
                        document.getElementById("container");
                      container.classList.remove("disable-scroll");
                    }}
                  />
                )} */}

                {showEndOfContentCard && (
                  <div
                    className="flex h-full w-full flex-col items-center justify-center"
                    // ref={endOfContentObserver}
                  >
                    <EndOfContent hasOlderContent={false} />
                  </div>
                )}

                {isFetchError && (
                  <ErrorEndOfContent
                    fetchFeedData={() => {
                      setIsMoreLoading(true);
                      fetchMoreData();
                    }}
                    hasOlderContent={true}
                  />
                )}
              </div>
            </div>
          ) : null}
          {isMoreLoading && (
            <div className="mt-6 px-5">
              <div className="h-40 w-full animate-pulse rounded bg-N200  dark:bg-DN200"></div>
              <div className=" mt-4 h-40 w-full animate-pulse  rounded bg-N200 dark:bg-DN200"></div>
            </div>
          )}
          {!isMoreLoading && data?.length ? (
            // data?.length > pageSize &&
            <>
              <div className="flex w-full justify-center">
                <div className="my-4 flex items-center px-4">
                  {Number(pageValue) === 0 ? (
                    <p className="mr-2 text-readingTextSmall leading-readingTextSmall text-N500 line-clamp-3 dark:text-DN500">
                      Prev
                    </p>
                  ) : (
                    <Link
                      href={
                        Number(pageValue) === (0 || 1)
                          ? `${baseUrl}/${[news]}`
                          : `${baseUrl}/${[news]}?page=${Number(pageValue)}`
                      }
                      passHref
                      prefetch={false}
                    >
                      <a
                        title="prev"
                        className={cx(
                          "text-readingTextSmall leading-readingTextSmall text-N900 line-clamp-3 dark:text-DN900"
                        )}
                      >
                        <p className="mr-2 text-readingTextSmall leading-readingTextSmall text-N900 line-clamp-3 dark:text-DN900">
                          Prev
                        </p>
                      </a>
                    </Link>
                  )}
                  {Number(pageValue) < 10 &&
                    [...Array(metaData.totalPages).keys()].slice(0, 10).map((el, id) => {
                      return (
                        <div className="mr-2" key={id}>
                          <Link
                            href={
                              el === 0
                                ? `${baseUrl}/${[news]}`
                                : `${baseUrl}/${[news]}?page=${el + 1}`
                            }
                            passHref
                            prefetch={false}
                          >
                            <a
                              title={(el + 1).toString()}
                              className={cx(
                                Number(pageValue) === el ? "font-bold" : "",
                                "text-readingTextSmall leading-readingTextSmall text-N900 line-clamp-3 dark:text-DN900"
                              )}
                            >
                              <span className="text-readingTextSmall">{el + 1}</span>
                            </a>
                          </Link>
                        </div>
                      );
                    })}
                  {Number(pageValue) % 10 === 0 &&
                    pageValue !== 0 &&
                    [...Array(metaData.totalPages).keys()]
                      .slice(Number(pageValue) - 1, Number(pageValue) + 10)
                      .map((el, id) => {
                        return (
                          <div className="mr-2" key={id}>
                            <Link
                              href={
                                el === 0
                                  ? `${baseUrl}/${[news]}`
                                  : `${baseUrl}/${[news]}?page=${el + 1}`
                              }
                              passHref
                              prefetch={false}
                            >
                              <a
                                title={(el + 1).toString()}
                                className={cx(
                                  Number(pageValue) === el ? "font-bold" : "",
                                  "text-readingTextSmall leading-readingTextSmall text-N900 line-clamp-3 dark:text-DN900"
                                )}
                              >
                                <span className="text-readingTextSmall">{el + 1}</span>
                              </a>
                            </Link>
                          </div>
                        );
                      })}
                  {Number(pageValue) % 10 !== 0 &&
                    Number(pageValue) > 10 &&
                    pageValue !== 0 &&
                    [...Array(metaData.totalPages).keys()]
                      .slice(
                        Math.floor(Number(pageValue) / 10) * 10 - 1,
                        Math.floor(Number(pageValue) / 10) * 10 + 1 + 9
                      )
                      .map((el, id) => {
                        return (
                          <div className="mr-2" key={id}>
                            <Link
                              href={
                                el === 0
                                  ? `${baseUrl}/${[news]}`
                                  : `${baseUrl}/${[news]}?page=${el + 1}`
                              }
                              passHref
                              prefetch={false}
                            >
                              <a
                                title={(el + 1).toString()}
                                className={cx(
                                  Number(pageValue) === el ? "font-bold" : "",
                                  "text-readingTextSmall leading-readingTextSmall text-N900 line-clamp-3 dark:text-DN900"
                                )}
                              >
                                <span className="text-readingTextSmall">{el + 1}</span>
                              </a>
                            </Link>
                          </div>
                        );
                      })}
                  {Number(pageValue) + 1 === metaData.totalPages ? (
                    <p className=" ml-1 text-readingTextSmall leading-readingTextSmall text-N500 line-clamp-3 dark:text-DN500">
                      Next
                    </p>
                  ) : (
                    <Link
                      href={`${baseUrl}/${[news]}?page=${Number(pageValue) + 2}`}
                      passHref
                      prefetch={false}
                    >
                      <a
                        title="next"
                        className={cx(
                          "text-readingTextSmall leading-readingTextSmall text-N900 line-clamp-3 dark:text-DN900"
                        )}
                      >
                        <p className="ml-1 text-readingTextSmall leading-readingTextSmall text-N900 line-clamp-3 dark:text-DN900">
                          Next
                        </p>
                      </a>
                    </Link>
                  )}
                </div>
              </div>
            </>
          ) : null}
          <div className="pos_right absolute bottom-9 z-[12] flex">
            <button
              className="flex h-[44px] w-[44px] items-center justify-center rounded-full bg-P500 p-3 shadow-customBottom shadow-[#0204092e]"
              onClick={() => {
                if (
                  window &&
                  window.__bgHistory &&
                  window.__bgHistory.lastLocation &&
                  window.__bgHistory.lastLocation?.includes("naukri")
                ) {
                  router.push(
                    `/naukri?mode=naukri&showTrendingFeed=${true}`,
                    "/naukri?mode=naukri"
                  );
                } else {
                  router.push(`/?showTrendingFeed=${true}`, "/");
                }
                // clickhouse.trackCTAs({
                //   element_name: "trending_floating_button",
                //   element_type: "floating_button",
                //   eventCategory: "click",
                // });
              }}
            >
              <img src={TrendingImg} alt="trending" />
            </button>
            {/* {(data.length || noContentRelatedFeed?.length) && !hideScrollToTop ? (
          <button
            className=" ml-2 flex h-[49px] w-[49px] items-center justify-center rounded-full bg-P500 p-3 shadow-customBottom shadow-[#0204092e]"
            onClick={() => scrollToTop()}
          >
            <img
              src={leftArrowWhiteImg}
              className="text-white h-[22px] w-[22px] rotate-90"
              alt="trending"
            />
          </button>
        ) : null} */}
          </div>
        </>
      )}
    </>
  );
};

export async function getServerSideProps(context) {
  const { query, req, res } = context;
  const page = query.page ? Number(query.page) - 1 : 0;
  try {
    const cookies = getCookies({ req, res });
    const firestore = new firestoreService();
    let userId = cookies["techminis_u_id"];
    let userData = await firestore.fetchUserData(userId, true, { req, res });
    // const db = getFirestore();
    // let userId = cookies["id"];
    // let userData;
    // if (userId) {
    //   const docRef = doc(db, "users", userId);
    //   const docSnap = userId ? await getDoc(docRef) : null;

    //   if (docSnap?.exists() && docSnap.data()) {
    //     userData = docSnap.data();
    //   }
    // } else {
    //   userId = nanoid();
    //   setCookie("id", userId, { req, res });
    //   userData = {
    //     id: userId,
    //     platform: "web",
    //     lastUpdatedDate: new Date(),
    //     preferences: [],
    //     savedKeywords: []
    //   };

    //   const userDetail = doc(db, "users", userId);
    //   await setDoc(userDetail, userData, { merge: true });
    // }

    let slugDetail = null;
    // const resTemp = await fetch(
    //   `https://techminis.com/api/seo/${query.news}/slugDetails`
    // );
    try {
      slugDetail = await http.get(urls.searchSlugDetails(encodeURI(query.news)), {
        headers: {
          uid: userData.id
        }
      });
      // if (!slugDetail || slugDetail.status === 404) {
      //   return {
      //     notFound: true,
      //   };
      // }
    } catch (error) {}

    let data = null;
    let noContentRelatedFeed = [];

    const fetchFeedData = async () => {
      try {
        if (slugDetail?.slugType === "tag") {
          data = await http.get(
            urls.searchSeoTag({
              id: encodeURI(slugDetail.slugRequestPayload),
              page: page,
              size: pageSize
            }),
            {
              headers: {
                uid: userData.id
              }
            }
          );
          if (page > data.totalPages) {
            res.statusCode = 404;
            return {
              notFound: true
            };
          }
        } else if (slugDetail?.slugType === "search") {
          data = await http.get(
            urls.searchSeoPagination({
              input: encodeURI(slugDetail.slugRequestPayload),
              page: page,
              size: pageSize
            }),
            {
              headers: {
                uid: userData.id
              }
            }
          );

          if (page > data.totalPages) {
            res.statusCode = 404;
            return {
              notFound: true
            };
          }
        }
      } catch (error) {}
    };

    const fetchNoContentRelatedFeedData = async () => {
      const url = urls.noContentFeed({ slug: encodeURI(query.news) });
      return http
        .get(url, { headers: { uid: userData.id } })
        .then((res: any) => {
          noContentRelatedFeed = getFeedDetails(res);
        })
        .catch(() => {});
    };
    if (Number(query.page) <= 0) {
      res.statusCode = 404;
      return {
        notFound: true
      };
    } else {
      await fetchFeedData();

      const feedDetail = data?.items
        ? Array.isArray(data?.items)
          ? getFeedDetails(data.items)
          : []
        : [];
      // Pass data to the page via props
      if (feedDetail.length === 0 && slugDetail) {
        await fetchNoContentRelatedFeedData();
      }

      const fetchDiscoverMoreTags = async () => {
        let url = urls.trendingDiscoverMoreTags;
        return http
          .get(url, { headers: { uid: userData.id } })
          .then((res: any) => {
            if (res.primary && res.primary.length) {
              discoverMoreTags = res.primary.map((i) => [i.slug, i.slugDisplayName]);
            } else {
              if (res.secondary && res.secondary.length) {
                discoverMoreTags = res.secondary.map((i) => [i.slug, i.slugDisplayName]);
              }
            }
          })
          .catch(() => {})
          .finally(() => {});
      };

      let discoverMoreTags = [];
      // console.log(discoverMoreTags);
      if (slugDetail && slugDetail?.relatedSlugDetails) {
        // Pass data to the page via props
        // console.log(slugDetail?.relatedSlugDetails);
        discoverMoreTags = slugDetail?.relatedSlugDetails
          ? Object.entries(slugDetail?.relatedSlugDetails)
          : [];
      }
      if (discoverMoreTags.length === 0) {
        await fetchDiscoverMoreTags();
      }

      if (!slugDetail) {
        res.statusCode = 404;
        return {
          notFound: true
        };
      }
      // console.log(data, slugDetail, discoverMoreTags);
      return {
        props: {
          data: feedDetail,
          slugDetail,
          discoverMoreTags,
          noContentRelatedFeed,
          metaData: data,
          pageValue: page,
          userLikeArticlesData: []
        }
      };
    }
  } catch (err) {
    serverErrorLogger({ err, req, screenName: "news_details" });
    return {
      props: { pageError: true }
    };
  }
}

export default SearchDetails;
